import { render, staticRenderFns } from "./msgTemplate.vue?vue&type=template&id=bfc7635a"
import script from "./msgTemplate.vue?vue&type=script&lang=js"
export * from "./msgTemplate.vue?vue&type=script&lang=js"
import style0 from "./msgTemplate.vue?vue&type=style&index=0&id=bfc7635a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc7635a')) {
      api.createRecord('bfc7635a', component.options)
    } else {
      api.reload('bfc7635a', component.options)
    }
    module.hot.accept("./msgTemplate.vue?vue&type=template&id=bfc7635a", function () {
      api.rerender('bfc7635a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/message/msgTemplate.vue"
export default component.exports